import Layout from '@layouts/Layout';
import Legal from '@screens/Legal';

import React, { memo } from 'react';

const title = 'Legal';
const description = 'The legal page of Traqq where you will find the links to privacy policy and terms of use. Click to find out more';

const LegalPage = () => (
    <Layout
        title={ title }
        description={ description }
    >
        <Legal />
    </Layout>
);

export default memo(LegalPage);
